<template lang="pug">
  div(:class="'textblock-'+this._uid")
    h1(class="block-title") {{this.title}}
    vue-markdown.desc(:source='this.body')
</template>

<script>

import Vue from 'vue'
import VueMarkdown from 'vue-markdown'
import textblockBase from '@/components/textblockBase.js'

// component instance
var Textblock = Vue.component('Textblock', {
  name: 'Textblock',
  mixins: [textblockBase],
  props: ['payload'],
  components: { VueMarkdown },
  data: function () {
    return {}
  },
  watch: {
  },
  methods: {
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Textblock
</script>

<style scoped>
  .page-title{

  }
</style>



// WEBPACK FOOTER //
// src/components/textblock.vue